<template>
  <div class="card floating delete">
    <div class="card-content">
      <h4><b>{{ $t('prompts.deleteDrive')}} {{ name }}?</b></h4>
      <p>{{ $t('prompts.deleteMessageDrive') }} <b>{{ name }}</b> {{ $t('prompts.deleteMessageDrive2') }}</p>
      <p>{{ $t('prompts.deleteConfirmMessage')}} <b>{{ name }}</b></p>
      <input v-focus class="input" type="text" v-model="nameDrive" :placeholder="name"> 
      <span v-if="isIncorrect">{{ $t('prompts.nameIncorrect')}}</span>
    </div>
    <div class="card-action">
      <button @click="$store.commit('closeHovers')" id ="buttonCancelDelete"
        class="button button--flat button--grey"
        :aria-label="$t('buttons.cancel')"
        :title="$t('buttons.cancel')">{{ $t('buttons.cancel') }}</button>
      <button @click="submit"
        class="button button--flat button--red" id ="buttonDelete" :disabled="nameDrive === ''"
        :aria-label="$t('buttons.delete')"
        :title="$t('buttons.delete')">{{ $t('buttons.delete') }}</button>
    </div>
  </div>
</template>

<script>
import {mapGetters, mapMutations, mapState} from 'vuex';
import { files as api } from '@/api';

export default {
  name: 'delete-shared-drive',
  data: function () {
    return {
      nameDrive: '',
      isIncorrect: false,
      name: ''
    };
  },
  mounted () {
    if (this.req[this.selected[0]]) {
      this.name = this.req[this.selected[0]].name;
    } else {
      this.name = this.req.items[this.selected[0]].name;
    }
    this.setIsPrompt(true);
    this.setIsRename(true);
  },
  computed: {
    ...mapGetters(['isListing', 'selectedCount', 'isSharedDrive', 'isLogged']),
    ...mapState(['req', 'selected', 'isRename', 'handleRecord', 'linkSharedDrive'])
  },
  methods: {
    ...mapMutations(['closeHovers', 'setIsPrompt', 'setIsRename', 'setParentHandle']),
    submit: async function () {
      if (this.nameDrive === this.name) {
        this.isIncorrect = false;
        document.getElementById('buttonDelete').disabled = true;
        document.getElementById('buttonCancelDelete').disabled = true;
        try {
          if (this.isSharedDrive) {
            for (let index of this.selected) {
              if (this.req[index] && (this.req[index].type === Module.NodeType.SHARED_DRIVE_ROOT.value)) {
                this.deleteNestedDrives(this.req[index].handle);
              } else if (this.req.items[index].type === Module.NodeType.SHARED_DRIVE_ROOT.value) {
                this.deleteNestedDrives(this.req.items[index].handle);
              } else {
                const {nodeList} = await ibb.getSortedChildren(this.req.handle, -Module.SortOrderType.SORT_ORDER_CREATION_TIME.value);
                for (let item of nodeList) {
                  if (item.name === this.req.items[index].name) {
                    await api.removeId(item.handle);
                  }
                }
              }
            }
            this.closeHovers();
            return;
          }

          this.closeHovers();
          this.$store.commit('setReload', true);
        } catch (e) {
          this.closeHovers();
          this.$showError(e);
          if (this.isListing) this.$store.commit('setReload', true);
        }
      } else {
        this.isIncorrect = true;
      }
    },
    async deleteNestedDrives (handle) {
      let nestedShares = await ibb.getSharedDrives();
      nestedShares = nestedShares.nodeList.filter(item => item.virtualParentHandle === handle);
      for (let sharedDrive of nestedShares) {
        this.deleteNestedDrives(sharedDrive.handle);
      }
      await ibb.deleteSharedDrive(handle);
    }
  },
  beforeDestroy () {
    this.setIsPrompt(false);
    this.setIsRename(false);
  }
};
</script>